var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_400_5166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47536 17.9982C7.1972 17.9982 4.91904 18.0033 2.64088 17.9961C1.08234 17.992 0.0135778 16.8779 0.00872858 15.2213C-0.00290953 11.0708 -0.00290953 6.91935 0.00872858 2.76891C0.0135778 1.11532 1.08622 0.00537903 2.64961 0.0043494C7.22145 -0.000798757 11.7943 -0.000798757 16.3661 0.0043494C17.9421 0.00640866 18.9633 1.10091 18.9769 2.77714C18.9885 4.30203 18.9885 4.31335 17.5241 4.29791C16.369 4.28555 15.2323 4.31644 14.1985 4.98261C12.6099 6.00709 11.7564 8.00355 12.1289 9.87542C12.5342 11.91 13.9531 13.3329 15.8414 13.6253C16.7114 13.7602 17.5832 13.6861 18.4532 13.6912C18.8518 13.6933 19.0079 13.8323 18.9808 14.2565C18.9556 14.6488 18.9808 15.0452 18.9721 15.4395C18.9401 16.8512 17.8839 17.9838 16.5504 17.992C14.1917 18.0074 11.833 17.9961 9.47342 17.9961C9.47536 17.9971 9.47536 17.9971 9.47536 17.9982Z",
    fill: "#FCD535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9981 8.99686C20.9981 9.95648 21.0029 10.9161 20.9961 11.8757C20.9913 12.5388 20.8051 12.7375 20.1863 12.7396C18.911 12.7447 17.6356 12.7519 16.3603 12.7375C14.4759 12.7159 12.895 10.983 12.9115 8.9773C12.928 6.98085 14.4914 5.28402 16.3545 5.26239C17.6298 5.24798 18.9051 5.25519 20.1805 5.26033C20.8031 5.26239 20.9913 5.45905 20.9961 6.11699C21.0029 7.0766 20.9981 8.03725 20.9981 8.99686Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_5166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletImg);
export default __webpack_public_path__ + "static/media/walletImg.3e9a3379cc4db758b36bee8649ab4261.svg";
export { ForwardRef as ReactComponent };